module.exports = "/packs/images/homepage/activity/swimming_desktop~468c792e0be6c9e770bce8507dba5dc9.jpg";